module.exports = __webpack_public_path__ + "h5/img/tuihuo.b0a8b44b.png";